export { default } from "./RedtailSection";
